var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 16 16",
    height: "16px",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,19.8l-3.2-3.2c-0.3-0.3-0.8-0.4-1.3-0.3c-0.4,0.2-0.7,0.6-0.7,1.1v0.5c0,0.1-0.1,0.2-0.2,0.2h-0.3V4.9 c0-0.1-0.1-0.2-0.1-0.3l-4.4-4.4C13.2,0.1,13,0,12.9,0H0.8C0.6,0,0.3,0.2,0.3,0.5v23c0,0.3,0.2,0.5,0.5,0.5h16.5 c0.3,0,0.5-0.2,0.5-0.5v-1.4h0.3c0.1,0,0.2,0.1,0.2,0.2v0.5c0,0.5,0.3,0.9,0.7,1.1c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.6-0.1,0.8-0.3 l3.2-3.2c0.1-0.1,0.1-0.2,0.1-0.3C23.7,20,23.6,19.9,23.5,19.8z M13.4,1.6l2.8,2.8h-2.8C13.4,4.4,13.4,1.6,13.4,1.6z M16.9,23H1.3 V1h11.1v4c0,0.3,0.2,0.5,0.5,0.5h4v12.7h-1c-0.3,0-0.5,0.2-0.5,0.5v3.1c0,0.3,0.2,0.5,0.5,0.5h1C16.9,22.3,16.9,23,16.9,23z  M19.7,23c-0.1,0.1-0.2,0.1-0.2,0c0,0-0.1-0.1-0.1-0.2v-0.5c0-0.6-0.5-1.2-1.2-1.2h-1.8V19h1.8c0.6,0,1.2-0.5,1.2-1.2v-0.5 c0-0.1,0.1-0.2,0.1-0.2s0.1,0,0.2,0l2.8,2.8L19.7,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,8.3h7.9c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H3.7c-0.3,0-0.5,0.2-0.5,0.5S3.4,8.3,3.7,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,10.5H3.7c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h10.8c0.3,0,0.5-0.2,0.5-0.5 C14.9,10.7,14.7,10.5,14.5,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,13.7H3.7c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h10.8c0.3,0,0.5-0.2,0.5-0.5 C14.9,13.9,14.7,13.7,14.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,16.8H3.7c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h10.8c0.3,0,0.5-0.2,0.5-0.5 C14.9,17,14.7,16.8,14.5,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,7.4h-1.1c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h1.1c0.3,0,0.5-0.2,0.5-0.5 C14.9,7.6,14.7,7.4,14.5,7.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtract);
export default __webpack_public_path__ + "static/media/extract.6a9aa2526260958f2dadbab5f10d1a5d.svg";
export { ForwardRef as ReactComponent };